import React from 'react';
import { useLocation, useParams } from 'react-router-dom';

export default function withRouteParams(Component) {
  function WithRouteParams(props) {
    const location = useLocation();
    const params = useParams();
    const query = React.useMemo(() => Object.fromEntries(new URLSearchParams(location.search)), [location.search]);

    return (
      <Component
        {...props}
        location={{
          ...location,
          query,
        }}
        params={params}
        routeParams={params}
      />
    );
  }

  WithRouteParams.displayName = `WithRouteParams(${Component.displayName || Component.name || 'Component'})`;

  return WithRouteParams;
}
